<template>
  <div>
    <div class="score-container" v-if="currentReport">
      <h3 class="title">Documents</h3>
      <div class="score" v-bind:style="getScoreStyle(currentReport.percentage)">
        <span>{{currentReport.percentage}} %</span>
      </div>
      <div style="margin-left: auto;"><b>{{user}}</b></div>
    </div>
    <div style="clear:both"></div>

    <div v-if="currentReport">
      <div class="report-wrapper">
        <table class="table table-responsive table-bordered intelligent-office">
          <thead>
          <tr>
            <td width="20%">Client file document name</td>
            <td width="20%">Alternate names</td>
            <td width="5%">FCA Regulations/Resources</td>

<!--            <td width="5%">ISA (cash)</td>-->
            <td width="5%">Cash bank account</td>
            <td width="5%">Current accounts</td>
            <td width="5%">Loans</td>
            <td width="5%">Savings</td>
            <td width="5%">Credit cards</td>
            <td width="5%">Mortgage</td>
            <td width="5%">Equity release</td>
            <td width="5%">Loan credit</td>
            <td width="5%">Investment portfolio (advised & discretionary)</td>
            <td width="5%">Investment portfolio (execution only)</td>
            <td width="5%">Annuity</td>
            <td width="5%">Pension</td>
            <td width="5%">Pension defined benefit</td>
            <td width="5%">Pension contribution drawdown</td>
            <td width="5%">Insurance general</td>
            <td width="5%">Life assured investment</td>
            <td width="5%">Personal protection</td>
            <td width="5%">Group protection</td>
            <td width="5%">General medical insurance</td>
            <td width="25%">Files</td>
          </tr>
          </thead>
          <tbody>
          <template v-for="(items, stage) in currentReport['plans']" :key="stage">
            <tr class="group-row" :class="stageClass(stage)">
              <td colspan="23">{{ stage }}</td>
            </tr>

            <tr v-for="doc in items">
              <td>{{ doc.title }}</td>

<!--              <td>-->
<!--                <ul v-if="doc.plan_alternative_names?.length" class="alt-names">-->
<!--                  <li v-for="(name, index) in doc.plan_alternative_names" :key="index">-->
<!--                    {{ name }}-->
<!--                  </li>-->
<!--                </ul>-->
<!--                <span v-else>-</span>-->
<!--              </td>-->

              <td>
                <div v-if="!doc.editAlternativeNames">
                  <ul v-if="doc.plan_alternative_names?.length" class="alt-names">
                    <li v-for="(name, index) in doc.plan_alternative_names" :key="index">
                      {{ name }}
                    </li>
                  </ul>

                  <span v-else>-</span>

                  <br>

                  <a
                      href="#"
                      class="edit-alt-names"
                      @click.prevent.stop="startEditAlternativeNames(doc)"
                  >
                    <i class="fa fa-pencil"></i>
                    Edit
                  </a>
                </div>

                <div v-else>
                  <div
                      v-for="(name, index) in doc.editableAlternativeNames"
                      :key="index"
                      class="alternative-name-row"
                  >
                    <input
                        type="text"
                        class="form-control alternative-name-input"
                        v-model="doc.editableAlternativeNames[index]"
                        :disabled="isDefaultAlternativeName(doc, name)"
                    >

                    <button
                        v-if="!isDefaultAlternativeName(doc, name)"
                        type="button"
                        class="btn btn-xs btn-danger note-button"
                        @click="removeAlternativeName(doc, index)"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>

                  <button
                      type="button"
                      class="btn btn-primary note-button"
                      @click="addAlternativeName(doc)"
                  >
                    <i class="fa fa-plus"></i>
                    Add
                  </button>

                  <br>

                  <button
                      type="button"
                      class="btn btn-primary note-button"
                      :disabled="doc.isSavingAlternativeNames"
                      @click="saveAlternativeNames(doc)"
                  >
                    Save
                  </button>

                  <button
                      type="button"
                      class="btn btn-secondary note-button"
                      :disabled="doc.isSavingAlternativeNames"
                      @click="cancelEditAlternativeNames(doc)"
                  >
                    Cancel
                  </button>

                  <div v-if="doc.isSavingAlternativeNames" class="status-message">
                    Saving...
                  </div>

                  <div v-if="doc.alternativeNamesSaveStatus === 'success'" class="status-message success">
                    Alternative names saved successfully!
                  </div>

                  <div v-if="doc.alternativeNamesSaveStatus === 'error'" class="status-message error">
                    Error saving alternative names.
                  </div>
                </div>
              </td>

              <td>
                <p class="print-link" v-for="resource in doc.fca_resource" :key="resource.link">
                  <a style="color: #337ab7;" :href="resource.link" target="_blank">{{resource.text}}</a>
                </p>
              </td>
<!--              <td v-for="(value,key) in doc.params">{{key}}: {{value}}-->
<!--                <div :class="{'color': value === 'red' || value === 'green', 'green': value === 'green'}"></div>-->
<!--              </td>-->

              <td v-for="key in paramOrder" :key="key">
                <div :class="{
                  'color': doc.params[key] === 'red' || doc.params[key] === 'green',
                  'green': doc.params[key] === 'green'
                }"></div>
              </td>

              <td class="text-right">
                <div class="print-link file-entry" v-for="(file, index) in doc.files" :key="file.download_link">
                  <a v-if="file.download_link" :href="file.download_link" class="file-name">
                    <i class="fa fa-download"></i> {{file.original_filename}}
                  </a>

                  <div v-if="isDocumentPresent(doc) && doc.monitor_document_type_slug" class="monitor-audit">
                    <a v-if="getMonitorDocumentId(doc, index)" :href="'/documents/view/' + getMonitorDocumentId(doc, index)" target="_blank">
                      <i class="fa fa-check-circle"></i> View report
                    </a>
                    <template v-else>
                      <a v-if="getAuditStatus(doc, index) !== 'loading'" class="edit-alt-names" v-on:click.prevent.stop="auditInMonitor(doc, index)">
                        <i class="fa fa-magic"></i> Audit in Monitor
                      </a>
                      <span v-else><i class="fa fa-spinner fa-spin"></i> Auditing...</span>
                      <div v-if="getAuditStatus(doc, index) === 'error'" class="status-message error">{{ getAuditError(doc, index) }}</div>
                    </template>
                  </div>
                </div>
              </td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IntellifloOfficePlansReportComponent",
  props: ["report", "user"],
  data() {
    return {
      currentReport: null,
      paramOrder: [
        'cash_bank_account',
        'current_accounts',
        'loans',
        'savings',
        'credit_cards',
        'mortgage',
        'equity_release',
        'loan_credit',
        'investment_portfolio_advised_discretionary',
        'investment_portfolio_execution_only',
        'annuity',
        'pensions',
        'pension_defined_benefit',
        'pension_contribution_drawdown',
        'insurance_general',
        'life_assured_investment',
        'personal_protection',
        'group_protection',
        'general_medical_insurance'
      ]
    };
  },
  mounted() {
    // this.currentReport = JSON.parse(this.report);
    this.currentReport = JSON.parse(this.report);

    Object.values(this.currentReport.plans || {}).forEach(items => {
      items.forEach(doc => {
        if (!Array.isArray(doc.plan_alternative_names)) {
          doc.plan_alternative_names = [];
        }

        doc.editAlternativeNames = false;
        doc.editableAlternativeNames = [];
        doc.isSavingAlternativeNames = false;
        doc.alternativeNamesSaveStatus = null;

        doc.monitor_document_ids = doc.monitor_document_ids || {};
        doc.auditInMonitorStatus = {};
        doc.auditInMonitorError = {};
      });
    });
  },
  methods: {
    getScoreStyle(score) {
      let color = '#2ECC71';
      let border = 'transparent';
      if (score === 0) {
        border = '#81c6e9';
        color = 'transparent';
      } else if (score < 34) {
        color = '#DE301D';
      } else if (score < 68) {
        color = '#F1C40F';
      }

      return {
        backgroundColor: color,
        borderColor: border,
      };
    },
    // saveNote(item) {
    //   item.isSaving = true;
    //   item.saveStatus = null;
    //   axios.post('/io/documents/report/save/notes', {
    //     id: item.id,
    //     notes: item.newNote,
    //   }).then(response => {
    //     item.saveStatus = 'success';
    //     item.notes.push({
    //       note: response.data.item.note ?? null,
    //       user: response.data.item.user ?? {},
    //       created_at: response.data.item.created_at,
    //       updated_at: response.data.item.updated_at
    //     });
    //     item.newNote = '';
    //     item.showTextarea = false;
    //   }).catch(() => {
    //     item.saveStatus = 'error';
    //   }).finally(() => {
    //     item.isSaving = false;
    //   });
    // },
    // formatDate(created_at, updated_at) {
    //   let date = created_at || updated_at;
    //   return date ? moment(date).format("DD.MM.YYYY HH:mm:ss") : '';
    // },
    stageClass(stage) {
      if(stage === 'Onboarding Documents') return 'group-blue';
      if(stage === 'Pre-Sale Documents') return 'group-yellow';
      if(stage === 'Post-Sale Documents') return 'group-green';
      return '';
    },
    // documentsByStage(stage) {
    //   console.log(stage, this.currentReport.plans, this.currentReport.plans.filter(d => d.stage === stage));
    //   return this.currentReport.plans.filter(d => d.stage === stage);
    // },

    startEditAlternativeNames(doc) {
      doc.editableAlternativeNames = [...(doc.plan_alternative_names || [])];
      doc.editAlternativeNames = true;
      doc.alternativeNamesSaveStatus = null;
    },

    addAlternativeName(doc) {
      doc.editableAlternativeNames.push('');
    },

    removeAlternativeName(doc, index) {
      doc.editableAlternativeNames.splice(index, 1);
    },

    cancelEditAlternativeNames(doc) {
      doc.editAlternativeNames = false;
      doc.editableAlternativeNames = [];
      doc.alternativeNamesSaveStatus = null;
    },

    saveAlternativeNames(doc) {
      doc.isSavingAlternativeNames = true;
      doc.alternativeNamesSaveStatus = null;

      axios.post('/io/plans/documents/report/save/alternative-names', {
        intelligent_office_data_id: doc.intelligent_office_data_id,
        title: doc.title,
        alternative_names: doc.editableAlternativeNames,
      }).then(response => {
        doc.plan_alternative_names = response.data.alternative_names || [];
        doc.editableAlternativeNames = [...doc.plan_alternative_names];
        doc.editAlternativeNames = false;
        doc.alternativeNamesSaveStatus = 'success';

        setTimeout(() => {
          doc.alternativeNamesSaveStatus = null;
        }, 3000);
      }).catch(() => {
        doc.alternativeNamesSaveStatus = 'error';

        setTimeout(() => {
          doc.alternativeNamesSaveStatus = null;
        }, 3000);
      }).finally(() => {
        doc.isSavingAlternativeNames = false;
      });
    },
    isDefaultAlternativeName(doc, name) {
      return (doc.default_plan_alternative_names || []).includes(name);
    },

    isDocumentPresent(doc) {
      return Object.values(doc.params || {}).includes('green');
    },

    getMonitorDocumentId(doc, index) {
      return (doc.monitor_document_ids || {})[index];
    },
    getAuditStatus(doc, index) {
      return (doc.auditInMonitorStatus || {})[index];
    },
    getAuditError(doc, index) {
      return (doc.auditInMonitorError || {})[index];
    },
    auditInMonitor(doc, index) {
      doc.auditInMonitorStatus[index] = 'loading';
      doc.auditInMonitorError[index] = null;

      axios.post('/io/documents/audit-in-monitor', {
        type: 'plan',
        id: doc.id,
        file_index: index,
      }).then(response => {
        doc.monitor_document_ids[index] = response.data.monitor_document_id;
        doc.auditInMonitorStatus[index] = 'success';
      }).catch(error => {
        doc.auditInMonitorStatus[index] = 'error';
        doc.auditInMonitorError[index] = error.response?.data?.message || 'Error auditing document in Monitor.';
      });
    },
  },
};
</script>

<style>
.intelligent-office tbody tr.group-row {
  text-align: center;
  font-weight: bold;
  color: #000;
}
.intelligent-office tbody tr.group-blue { background-color: #4fc3f7; }
.intelligent-office tbody tr.group-yellow { background-color: #ffe082; }
.intelligent-office tbody tr.group-green { background-color: #aed581; }

.intelligent-office td .alt-names li {
  float: none;
  display: list-item;
  margin-right: 0;
  background: none;
  border-radius: 0;
  padding: 0;
}
.intelligent-office td .alt-names {
  list-style-type: disc;
  padding-left: 16px;
  margin: 0;
}
.alternative-name-row {
  display: flex;
  gap: 5px;
  margin-bottom: 5px;
}

.alternative-name-input {
  min-width: 180px;
}

.alt-name-button {
  margin-top: 5px;
  margin-right: 5px;
}

.status-message {
  margin-top: 5px;
  font-size: 12px;
}

.status-message.success {
  color: #28a745;
}

.status-message.error {
  color: #dc3545;
}

.edit-alt-names {
  font-size: 12px;
  color: #337ab7;
  cursor: pointer;
}
.add-note {
  cursor: pointer;
}
.file-entry {
  display: block;
  max-width: 300px;
  text-align: left;
  background-color: #f4f7f7;
  border: 1px solid #dcdcdc;
  border-radius: 6px;
  padding: 6px 10px;
  margin-bottom: 6px;
}
.file-entry .file-name {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.monitor-audit {
  display: block;
  margin-top: 4px;
  padding-top: 4px;
  border-top: 1px dashed #dcdcdc;
  white-space: nowrap;
}
.monitor-audit .status-message {
  white-space: normal;
  word-break: break-word;
}
</style>
